import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
app.initializers.add('val-ui-editor-tools', () => {
  const start = () => {
    const smilies = window.valUiSmilies || [];
    const models = window.valUiModels || [];
    const isAdmin = !!(app.session && app.session.user && app.session.user.isAdmin && app.session.user.isAdmin());
    const visibleModels = models.filter(function (model) {
      return model.auth === 0 || isAdmin;
    }).sort(function (a, b) {
      if (a.auth === 0 && b.auth !== 0) return -1;
      if (a.auth !== 0 && b.auth === 0) return 1;
      return 0;
    });

    /*
     * Les modèles de messages VAL sont destinés aux messages publics.
     * On les retire des discussions privées Byobu.
     */
    const valIsPrivateComposer = function (editor) {
      const composer = editor && editor.attrs && editor.attrs.composer ? editor.attrs.composer : null;
      const body = composer && composer.body ? composer.body : null;
      const bodyAttrs = body && body.attrs ? body.attrs : {};

      /*
       * Réponse dans une discussion privée existante.
       */
      const discussion = bodyAttrs.discussion || (composer ? composer.discussion : null) || (app.current && app.current.data ? app.current.data.discussion : null);
      if (discussion && discussion.isPrivateDiscussion && discussion.isPrivateDiscussion()) {
        return true;
      }

      /*
       * Création d'un nouveau MP Byobu :
       * il n'y a pas encore forcément de Discussion.
       */
      if (bodyAttrs.recipientUsers || bodyAttrs.recipientGroups) {
        return true;
      }

      /*
       * Sécurité supplémentaire pour le composant
       * de création Byobu.
       */
      const bodyName = String(body && body.constructor && body.constructor.name ? body.constructor.name : '');
      return bodyName.indexOf('PrivateDiscussion') !== -1 || bodyName.indexOf('Byobu') !== -1;
    };

    /* =========================
       AUTOCOMPLÉTION : -> SMILEYS VAL
       ========================= */

    const valColonContainer = function (editor) {
      if (!editor || !editor.$) return null;
      return editor.$(".ComposerBody-emojiDropdownContainer")[0] || null;
    };
    const valColonIsOpen = function (editor) {
      const container = valColonContainer(editor);
      return !!(container && container.dataset && container.dataset.valColonSmileys === "1");
    };

    /*
     * Fermeture forte du panneau ":".
     * On ne dépend volontairement d'aucun flag stocké sur TextEditor :
     * le conteneur DOM lui-même indique si le panneau VAL est ouvert.
     */
    const closeValColonSmileys = function (editor) {
      if (!editor) return;
      if (editor.emojiDropdown) {
        try {
          editor.emojiDropdown.hide();
        } catch (err) {}
        editor.emojiDropdown.active = false;
      }
      const container = valColonContainer(editor);
      if (container && container.dataset && container.dataset.valColonSmileys === "1") {
        delete container.dataset.valColonSmileys;
        m.render(container, null);
      }
    };

    /*
     * Clic hors panneau + Échap.
     * Binding une seule fois pour chaque textarea construit par Flarum.
     */
    extend(TextEditor.prototype, "onbuild", function () {
      const editor = this;
      const input = editor.$(".TextEditor-editor")[0];
      if (!input || input.dataset.valColonCloseBound === "1") {
        return;
      }
      input.dataset.valColonCloseBound = "1";
      document.addEventListener("mousedown", function (e) {
        if (!valColonIsOpen(editor)) return;
        const container = valColonContainer(editor);
        if (!container || !container.contains(e.target)) {
          closeValColonSmileys(editor);
        }
      }, true);
      document.addEventListener("keydown", function (e) {
        if ((e.key === "Escape" || e.key === "Enter") && valColonIsOpen(editor)) {
          /*
           * Aucun smiley ne doit être validé au clavier.
           * Pour Entrée, on ferme seulement le panneau :
           * l'évènement continue ensuite normalement jusqu'au
           * textarea et produit donc le retour à la ligne.
           */
          closeValColonSmileys(editor);
        }
      }, true);
    });
    extend(TextEditor.prototype, "buildEditorParams", function (params) {
      const editor = this;
      params.inputListeners.push(function () {
        if (!editor.emojiDropdown || !editor.attrs || !editor.attrs.composer || !editor.attrs.composer.editor) {
          closeValColonSmileys(editor);
          return;
        }
        const textEditor = editor.attrs.composer.editor;
        const selection = textEditor.getSelectionRange();
        const cursor = selection[0];
        if (selection[1] !== cursor) {
          closeValColonSmileys(editor);
          return;
        }
        const lastChunk = textEditor.getLastNChars(64);
        const colonIndex = lastChunk.lastIndexOf(":");

        /* Suppression du ":" : fermeture immédiate. */
        if (colonIndex < 0) {
          closeValColonSmileys(editor);
          return;
        }
        const typed = lastChunk.slice(colonIndex + 1);
        const before = colonIndex > 0 ? lastChunk.charAt(colonIndex - 1) : "";
        const alphaNum = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        const allowed = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_+-";
        if (before && alphaNum.indexOf(before) !== -1) {
          closeValColonSmileys(editor);
          return;
        }
        for (const character of typed) {
          if (allowed.indexOf(character) === -1) {
            closeValColonSmileys(editor);
            return;
          }
        }
        const query = typed.toLowerCase();
        const matches = smilies.filter(function (smiley) {
          const code = String(smiley.code || "").toLowerCase();
          return !query || code.indexOf(query) !== -1;
        });

        /*
         * Le listener Emoji natif est passé avant le nôtre.
         * On masque son résultat puis on réutilise son conteneur.
         * Le vrai bouton Emoji reste, lui, totalement indépendant.
         */
        editor.emojiDropdown.hide();
        editor.emojiDropdown.active = false;
        if (!matches.length) {
          closeValColonSmileys(editor);
          return;
        }
        const tokenStart = cursor - typed.length - 1;
        editor.emojiDropdown.items = matches.map(function (smiley) {
          return m("button", {
            type: "button",
            key: smiley.code,
            className: "val-smiley-item",
            title: smiley.code,
            onclick: function (e) {
              e.preventDefault();
              e.stopPropagation();
              textEditor.replaceBeforeCursor(tokenStart, smiley.code + " ");

              /*
               * replaceBeforeCursor relance les listeners.
               * On ferme donc aussi au tour d'évènement suivant,
               * une fois tous les listeners terminés.
               */
              closeValColonSmileys(editor);
              window.setTimeout(function () {
                closeValColonSmileys(editor);
                m.redraw();
              }, 0);
            }
          }, m("img", {
            src: "/assets/smilies/" + encodeURIComponent(smiley.file),
            alt: smiley.code,
            style: {
              maxWidth: "32px",
              maxHeight: "32px"
            }
          }));
        });
        const container = valColonContainer(editor);
        if (!container) {
          return;
        }
        m.render(container, editor.emojiDropdown.render());
        container.dataset.valColonSmileys = "1";
        const header = editor.$(".ComposerBody-emojiDropdownContainer .Dropdown-header");
        if (header.length) {
          header.text("Smileys VAL");
        }

        /*
         * Pas de sélection par défaut : un smiley VAL
         * ne peut être inséré qu'en cliquant dessus.
         */
        editor.emojiDropdown.$().scrollTop(0);
        editor.emojiDropdown.show();
        const coordinates = textEditor.getCaretCoordinates(tokenStart);
        const width = editor.emojiDropdown.$().outerWidth() || 0;
        const height = editor.emojiDropdown.$().outerHeight() || 0;
        const parent = editor.emojiDropdown.$().offsetParent();
        let left = coordinates.left;
        let top = coordinates.top + 15;
        if (parent && parent.length) {
          const parentHeight = parent.height() || 0;
          const parentWidth = parent.width() || 0;
          if (top + height > parentHeight) {
            top = coordinates.top - height - 15;
          }
          if (left + width > parentWidth) {
            left = parentWidth - width;
          }
          const parentOffset = parent.offset();
          if (parentOffset) {
            top = Math.max(-(parentOffset.top - $(document).scrollTop()), top);
            left = Math.max(-parentOffset.left, left);
          }
        }
        editor.emojiDropdown.show(left, top);
        editor.emojiDropdown.active = true;
      });
    });

    /* =========================
       MARKDOWN — remplacer « Insérer une image »
       par « Lien vers une image »
       ========================= */

    if (typeof TextEditor.prototype.markdownToolbarItems === "function") {
      extend(TextEditor.prototype, "markdownToolbarItems", function (items) {
        const imageButton = items.get("image");
        if (!imageButton || !imageButton.attrs) return;
        imageButton.attrs.title = "Lien vers une image";
        imageButton.attrs.onclick = () => {
          const driver = this.attrs && this.attrs.composer && this.attrs.composer.editor;
          if (!driver || !driver.el) return;
          const textarea = driver.el;
          const start = textarea.selectionStart;
          const end = textarea.selectionEnd;
          const selected = textarea.value.slice(start, end).trim();
          const url = window.prompt("URL de l’image :", "");
          if (url === null || !url.trim()) return;
          const label = window.prompt("Texte du lien :", selected || "Voir l’image");
          if (label === null) return;
          const linkText = "[" + (label.trim() || "Voir l’image") + "](" + url.trim() + ")";
          if (start !== end) {
            driver.insertBetween(start, end, linkText);
          } else {
            driver.insertAtCursor(linkText);
          }
        };
      });
    }
    extend(TextEditor.prototype, "toolbarItems", function (items) {
      const editor = this;

      /* =========================
         ÉMOJIS — vrai bouton, sans insertion de ":"
         ========================= */

      /*
       * flarum/emoji 2.0.0-rc.7 fournit un bouton qui insère " :"
       * pour déclencher son autocomplétion au curseur. On retire
       * seulement cette entrée de barre d'outils et on la remplace
       * par un panneau indépendant. Le listener natif de saisie ":"
       * n'est pas modifié.
       */
      items.remove("emoji");
      const emojiList = Array.isArray(editor.commonEmoji) && editor.commonEmoji.length ? editor.commonEmoji : ["😀", "😁", "😂", "😃", "😄", "😅", "😆", "😇", "😈", "😉", "😊", "😋", "😌", "😍", "😎", "😏", "😐️", "😑", "😒", "😓", "😔", "😕", "😖", "😗", "😘", "😙", "😚", "😛", "😜", "😝", "😞", "😟", "😠", "😡", "😢", "😣", "😤", "😥", "😦", "😧", "😨", "😩", "😪", "😫", "😬", "😭", "😮", "😯", "😰", "😱", "😲", "😳", "😴", "😵", "😶", "😷", "😸", "😹", "😺", "😻", "😼", "😽", "😾", "😿", "🙀", "🙁", "🙂", "🙃", "🙄"];
      items.add("emoji", m("div", {
        className: "val-emoji-picker"
      }, [m("button", {
        type: "button",
        className: "Button Button--icon Button--link val-emoji-picker-button" + (editor.valEmojiPickerOpen ? " is-open" : ""),
        title: "Émojis",
        "aria-label": "Émojis",
        "aria-expanded": editor.valEmojiPickerOpen ? "true" : "false",
        onclick: function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeValColonSmileys(editor);
          editor.valSmileyPickerOpen = false;
          editor.valModelPickerOpen = false;
          editor.valEmojiPickerOpen = !editor.valEmojiPickerOpen;
          m.redraw();
        }
      }, m("i", {
        className: "icon far fa-laugh-beam"
      })), editor.valEmojiPickerOpen ? m("div", {
        className: "val-emoji-panel",
        role: "menu",
        onclick: function (e) {
          e.stopPropagation();
        },
        oncreate: function (vnode) {
          const root = vnode.dom.closest(".val-emoji-picker");
          vnode.state.valCloseOutside = function (event) {
            if (root && !root.contains(event.target)) {
              editor.valEmojiPickerOpen = false;
              m.redraw();
            }
          };
          vnode.state.valCloseEscape = function (event) {
            if (event.key === "Escape") {
              editor.valEmojiPickerOpen = false;
              m.redraw();
            }
          };
          document.addEventListener("mousedown", vnode.state.valCloseOutside, true);
          document.addEventListener("keydown", vnode.state.valCloseEscape, true);
        },
        onremove: function (vnode) {
          if (vnode.state.valCloseOutside) {
            document.removeEventListener("mousedown", vnode.state.valCloseOutside, true);
          }
          if (vnode.state.valCloseEscape) {
            document.removeEventListener("keydown", vnode.state.valCloseEscape, true);
          }
        }
      }, emojiList.map(function (emoji) {
        return m("button", {
          type: "button",
          className: "val-emoji-item",
          title: emoji,
          "aria-label": emoji,
          onclick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            editor.attrs.composer.editor.insertAtCursor(emoji);
            editor.valEmojiPickerOpen = false;
            m.redraw();
          }
        }, emoji);
      })) : null]), 60);

      /* =========================
         SMILEYS
         ========================= */

      items.add("val-smileys", m("div", {
        className: "val-smiley-picker"
      }, [m("button", {
        type: "button",
        className: "Button Button--icon Button--link val-smiley-picker-button" + (editor.valSmileyPickerOpen ? " is-open" : ""),
        title: "Smileys VAL",
        onclick: function (e) {
          e.preventDefault();
          e.stopPropagation();
          editor.valModelPickerOpen = false;
          editor.valEmojiPickerOpen = false;
          editor.valSmileyPickerOpen = !editor.valSmileyPickerOpen;
          m.redraw();
        }
      }, m("i", {
        className: "icon far fa-grin-tongue-wink"
      })), editor.valSmileyPickerOpen ? m("div", {
        className: "val-smiley-panel",
        onclick: function (e) {
          e.stopPropagation();
        },
        oncreate: function (vnode) {
          const root = vnode.dom.closest(".val-smiley-picker");
          vnode.state.valCloseOutside = function (event) {
            if (root && !root.contains(event.target)) {
              editor.valSmileyPickerOpen = false;
              m.redraw();
            }
          };
          vnode.state.valCloseEscape = function (event) {
            if (event.key === "Escape") {
              editor.valSmileyPickerOpen = false;
              m.redraw();
            }
          };
          document.addEventListener("mousedown", vnode.state.valCloseOutside, true);
          document.addEventListener("keydown", vnode.state.valCloseEscape, true);
        },
        onremove: function (vnode) {
          if (vnode.state.valCloseOutside) {
            document.removeEventListener("mousedown", vnode.state.valCloseOutside, true);
          }
          if (vnode.state.valCloseEscape) {
            document.removeEventListener("keydown", vnode.state.valCloseEscape, true);
          }
        }
      }, smilies.map(function (smiley) {
        return m("button", {
          type: "button",
          className: "val-smiley-item",
          title: smiley.code,
          onclick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            editor.attrs.composer.editor.insertAtCursor(smiley.code);
            editor.valSmileyPickerOpen = false;
            m.redraw();
          }
        }, m("img", {
          src: "/assets/smilies/" + encodeURIComponent(smiley.file),
          alt: smiley.code
        }));
      })) : null]), 50);

      /* =========================
         MODÈLES DE MESSAGES
         ========================= */

      if (!valIsPrivateComposer(editor)) {
        items.add("val-postmodels", m("div", {
          className: "val-model-picker"
        }, [m("button", {
          type: "button",
          className: "Button Button--icon Button--link val-model-picker-button" + (editor.valModelPickerOpen ? " is-open" : ""),
          title: "Modèles de messages",
          onclick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            editor.valSmileyPickerOpen = false;
            editor.valEmojiPickerOpen = false;
            editor.valModelPickerOpen = !editor.valModelPickerOpen;
            m.redraw();
          }
        }, m("i", {
          className: "icon far fa-file-alt"
        })), editor.valModelPickerOpen ? m("div", {
          className: "val-model-panel",
          onclick: function (e) {
            e.stopPropagation();
          }
        }, visibleModels.map(function (model, index) {
          const children = [];

          /*
           * Chez les admins :
           * séparation visuelle entre
           * modèles réservés et modèles publics.
           */
          if (isAdmin && index > 0 && visibleModels[index - 1].auth !== 0 && model.auth === 0) {
            children.push(m("div", {
              className: "val-model-separator"
            }));
          }
          children.push(m("button", {
            type: "button",
            className: "val-model-item",
            title: model.title,
            onclick: function (e) {
              e.preventDefault();
              e.stopPropagation();
              editor.attrs.composer.editor.insertAtCursor(model.content);
              editor.valModelPickerOpen = false;
              m.redraw();
            }
          }, model.title));
          return children;
        })) : null]), 40);
      }
    });
  };
  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, {
      once: true
    });
  }
});